// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useCallback, useState} from 'react';
import cn from 'classnames';
import etask from '/util/etask.js';
import {Text} from '@pub/comp/text';
import {Button} from '@pub/comp/button';
import {write_clipboard, supports} from '@pub/utils/clipboard.js';
import * as cns from './copy_row.module.less';

export function Copy_row({className, value, disabled}){
    const [copied, set_copied] = useState();
    const copy_click = useCallback(()=>etask(function*(){
        yield write_clipboard(value);
        set_copied('Copied!');
        setTimeout(set_copied, 1000);
    }), [value]);
    return <div className={cn(cns.root, className)}>
      <Text.s className={cn(cns.text, cns.child)} disabled={copied||disabled}
        mono>
        {copied||value}
      </Text.s>
      {supports()&&<Button className={cns.child} ico="copy"
        on_click={copy_click} disabled={disabled} size="xs" filled
        color_scheme="tertiary">
        Copy
      </Button>}
    </div>;
}
